import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import "./CloseButton.scss";

const CloseButton = ({ onClick, ariaLabel }) => {
  const intl = useIntl();
  const label = ariaLabel || intl.formatMessage({ id: "close", defaultMessage: "Close" });
  return (
    <button
      type="button"
      className="modal-close-btn"
      onClick={onClick}
      aria-label={label}
    >
      <span aria-hidden="true">&times;</span>
    </button>
  );
};

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
};

export default CloseButton;
